
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Cascader from './cascaderInner.vue';
import { isUndef } from '@/lib/utils';

@Component({
    name: 'CustomCascader',
    components: {
        Cascader,
    },
})
export default class CustomCascader extends Vue {
    /** title */
    @Prop({ type: String }) public title?: string;
    /** titleHint */
    @Prop({ type: Boolean }) public required?: boolean;
    @Prop({ type: Array, default() { return []; } }) public value?: number[];
    @Prop({ type: String, default: '请选择' }) public placeholder?: string;
    @Prop({ required: true, type: Function }) public fetchList!: <T extends CascaderItem>(item: T) => T[] | Promise<T[]>;
    /** 数据是否有效 */
    @Prop({ type: Boolean, default: true }) public isValidate?: boolean;
    /** class */
    @Prop() public clazz?: any;
    /** 文本对齐 */
    @Prop({ type: String, default: 'right' }) public textAlign!: string;
    /** 是否显示右边箭头 */
    @Prop({ type: Boolean, default: false }) public rightArrow?: boolean;
    /** 是否禁用 */
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    /** 颜色 */
    @Prop({ type: String }) public color?: string;

    public maxLevel = 3;

    public visible = false;
    public ids: number[] = [];
    public itemMap: { [id: number]: CascaderItem } = {};
    public listMap: { [id: number]: CascaderItem[] } = {};

    public get name() {
        if (!this.itemMap) {
            return '';
        }
        return (this.value || []).map((id) => this.itemMap![id] ? this.itemMap![id].name : '').join('');
    }

    /**
     * 如果没有的情况下，返回null
     *
     * @return {Number|null} 最后一级districtId，当没有districtIds时候返回null
     */
    public get lastId() {
        const len = this.ids.length;
        if (len === 0) {
            return null;
        }
        return this.ids[len - 1];
    }

    /**
     * 指示下一列是否存在
     *
     * 1. 当前列数>=3的情况 -> false
     * 2. isUndef(lastDistrictId) -> true
     * 3. district的level达到标准的情况下 -> false
     * 4. !list == null && !(list.length === 0)
     */
    public get moreColumnVisible() {
        // 如果列数已经到达了3
        if (this.ids.length >= this.maxLevel) {
            return false;
        }
        // 如果最后一个districtId不存在情况下，表明当前没有任何级别被选中
        const lastId = this.lastId;
        // 如果最后一级的list不存在，那么返回false
        if (isUndef(this.listMap[lastId!]) || !this.listMap[lastId!].length) {
            return false;
        }
        if (isUndef(lastId)) {
            return true;
        }
        return true;
    }

    @Watch('ids')
    public onUpdateIds() {
        this.$emit('input', this.ids);
    }

    public onItemMapUpate(itemMap: { [id: number]: CascaderItem }) {
        this.itemMap = itemMap;
    }

    public onListMapUpate(listMap: { [id: number]: CascaderItem[] }) {
        this.listMap = listMap;
    }

    public onClickPlaceholder() {
        if (this.disabled) {
            return;
        }
        this.visible = true;
    }

    public onFinish() {
        this.visible = false;
    }

    public async innerFetchList(item: CascaderItem) {
        const ret = await this.fetchList(item);
        for (let i = 0, len = ret.length ; i < len; i++) {
            this.$set(this.itemMap, ret[i].id, ret[i]);
        }
        return ret;
    }

    public created() {
        this.innerFetchList({ id: 0, name: '' });
        if (this.value && this.value.length) {
            for (let i = 0, len = this.value.length; i < len; i++) {
                this.innerFetchList({ id: this.value[i], name: '' });
            }
        }
    }
}
